// extracted by mini-css-extract-plugin
export default {"cls1":"GiftShop_cls1__LjdaP","cls2":"GiftShop_cls2__AtE93","cls3":"GiftShop_cls3__M1iiD","cls4":"GiftShop_cls4__jqjqn","cls5":"GiftShop_cls5__JeNlH"};